import React, { createContext, useContext, useState, useEffect } from 'react';
import BadgeEarnedPopup from '../components/profile/BadgeEarnedPopup';
import { useAuth } from './AuthContext';

const BadgeContext = createContext();

export const BadgeProvider = ({ children }) => {
  const [badgePopup, setBadgePopup] = useState({
    isVisible: false,
    badge: null
  });
  const [newBadgeCheck, setNewBadgeCheck] = useState(false);
  const { user, isAuthenticated } = useAuth();

  // Function to show badge earned popup
  const showBadgeEarned = (badge) => {
    setBadgePopup({
      isVisible: true,
      badge
    });
  };

  // Function to hide badge popup
  const hideBadgePopup = () => {
    setBadgePopup({
      isVisible: false,
      badge: null
    });
    
    // Mark the badge as seen in the backend
    if (badgePopup.badge && isAuthenticated) {
      // API call to mark badge as seen
      // Example: api.badges.markAsSeen(badgePopup.badge.id);
    }
  };

  // Check for new badges when user logs in or performs certain actions
  const checkForNewBadges = async () => {
    if (!isAuthenticated) return;
    
    try {
      // API endpoint to check for new badges
      // const response = await api.get('/api/badges/new/');
      // if (response.data.newBadge) {
      //   showBadgeEarned(response.data.newBadge);
      // }
      
      // For now, we'll use mock data
      setNewBadgeCheck(false);
    } catch (error) {
      console.error('Error checking for new badges:', error);
    }
  };

  // Trigger badge check when requested
  useEffect(() => {
    if (newBadgeCheck) {
      checkForNewBadges();
    }
  }, [newBadgeCheck, isAuthenticated]);

  // Value to provide in the context
  const value = {
    showBadgeEarned,
    checkForNewBadges: () => setNewBadgeCheck(true)
  };

  return (
    <BadgeContext.Provider value={value}>
      {children}
      <BadgeEarnedPopup 
        badge={badgePopup.badge}
        isVisible={badgePopup.isVisible}
        onClose={hideBadgePopup}
      />
    </BadgeContext.Provider>
  );
};

export const useBadge = () => useContext(BadgeContext);
